import { render, staticRenderFns } from "./pcSwiper.vue?vue&type=template&id=27501047&"
import script from "./pcSwiper.vue?vue&type=script&lang=js&"
export * from "./pcSwiper.vue?vue&type=script&lang=js&"
import style0 from "./pcSwiper.vue?vue&type=style&index=0&id=27501047&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports